import {Price} from './types';

export function getBeginningOfTheDay(date: Date): Date {
  const day = date.getDate();
  const month = date.getMonth();
  const year = date.getFullYear();
  return new Date(year, month, day);
}

export function getNextDay(date: Date): Date {
  const beginningOfTheDay = getBeginningOfTheDay(date);
  return new Date(beginningOfTheDay.valueOf() + 24 * 3600 * 1000);
}

export function truncate(str: string, n: number, useWordBoundary: boolean) {
  if (str.length <= n) {
    return str;
  }
  const subString = str.substr(0, n - 1); // the original check
  return (useWordBoundary ? subString.substr(0, subString.lastIndexOf(' ')) : subString) + '...';
}

export function lang() {
  return navigator.language;
}

export function formatBudget(value: number | string, currency = 'USD', suffix = '', maximumFractionDigits = 0) {
  let defaultValue = '';
  if (!value) {
    return defaultValue;
  }
  let formatter = new Intl.NumberFormat(lang(), {maximumFractionDigits});
  try {
    const options =
      currency === 'AMEX_POINT' ? {maximumFractionDigits} : {style: 'currency', currency, maximumFractionDigits};
    formatter = new Intl.NumberFormat(lang(), options);
  } catch {
    //
  }
  const v = parseInt(value.toString(), 10);
  if (v > 0) {
    defaultValue = formatter.format(v);
  }
  return `${defaultValue} ${currency === 'AMEX_POINT' && defaultValue ? suffix : ''}`.trim();
}

export function formatPrices(prices: Price[], pointsName = '', maximumFractionDigits = 0) {
  const hash = prices.reduce((h: Record<string, number>, x) => {
    h[x.currency] = h[x.currency] ? h[x.currency] + x.amount : x.amount;
    return h;
  }, {});
  const hashValue = Object.keys(hash).reduce((r: Record<string, string>, x) => {
    r[x] = formatBudget(hash[x], x, pointsName, maximumFractionDigits);
    return r;
  }, {});
  const combined = Object.keys(hash).map((key) => {
    return {
      amount: hash[key],
      currency: key,
    };
  });
  return {
    prices: combined,
    values: {
      ...hash,
    },
    labels: {
      ...hashValue,
    },
  };
}
